module.exports = __webpack_public_path__ + "static/logo-horizontal-blue-wording-e91bf86ed4b1e5558c25b1efc03df96b.png";